import {Component , OnInit} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {OrganizationsService} from '../../../../core/services/organizations.service';
import {Router} from '@angular/router';
import {fuseAnimations} from '../../../../core/animations';
import { numberValidator, websiteValidator } from '../../../../core/validators/validators';
import { CheckModalComponent } from '../../check-save-modal/check-modal';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from "rxjs";
import {FuseConfigService} from "../../../../core/services/config.service";
import {ToastrService } from "ngx-toastr";
@Component({
    selector: 'organization-new-page',
    templateUrl: './organization-new.component.html',
    styleUrls: ['./organization-new.component.scss'],
    animations: fuseAnimations,
    standalone: false
})
export class OrganizationNewComponent implements OnInit  {
  public formGroup: FormGroup = new FormGroup({
    name: new FormControl('', Validators.required),
    countryId: new FormControl('', Validators.required),
    cityId: new FormControl('', Validators.required),
    cityLocation: new FormControl('', Validators.required),
    lang: new FormControl('', Validators.required),
    organizationTypeId: new FormControl('', Validators.required),
    address: new FormControl(''),
    postcode: new FormControl('', [numberValidator]),
    website: new FormControl('', [websiteValidator]),
    phone: new FormControl(''),
    whatsapp: new FormControl({value: '', disabled: true}),
    allowCompetency: new FormControl({value: '', disabled: true}),
    allowTimeAndBudget: new FormControl({value: '', disabled: true}),
  });
  public languages = [ {label: 'English' , value: 'en'} , {label: 'Deutsch' , value: 'de'}, {label: 'Français' , value: 'fr'} ];

  public img: any = '';
  public uploadedImg = null;
  public countries = [];
  public cities = [];
  public types = [];
  public defaultForm;
  public returnBack;

  constructor ( private organizationService: OrganizationsService ,
               private router: Router,
               public dialog: MatDialog, public snackBar: MatSnackBar,
               private fuseConfig: FuseConfigService, public toastr: ToastrService ) {
    this.organizationService.getCountry().subscribe((result: any) => {
      this.countries = result;
      this.organizationService.getOrganizationType().subscribe((typeResult: any) => {
        this.types = typeResult;
        this.initForm();
      });
    });
  }

  ngOnInit () {

  }
  canDeactivate(): Observable<boolean> | boolean {
    return this.goBack();
  }

  initForm () {
    this.formGroup.patchValue({lang: 'de'});
    // this.formGroup.get('whatsapp').valueChanges.subscribe((res) => {
    //   const inputControlAccountSid = this.formService.findById('accountSid' , this.formModel) as DynamicInputModel;
    //   const inputControlAuthToken = this.formService.findById('authToken' , this.formModel) as DynamicInputModel;
    //   if (res) {
    //     inputControlAccountSid.hidden = false;
    //     inputControlAuthToken.hidden = false;
    //     inputControlAccountSid.required = true;
    //     inputControlAuthToken.required = true;
    //     this.formGroup.controls.accountSid.setValidators([Validators.required]);
    //     this.formGroup.controls.authToken.setValidators([Validators.required]);
    //   } else {
    //     inputControlAccountSid.hidden = true;
    //     inputControlAuthToken.hidden = true;
    //     inputControlAccountSid.required = false;
    //     inputControlAuthToken.required = false;
    //     this.formGroup.controls.accountSid.setValidators([]);
    //     this.formGroup.controls.authToken.setValidators([]);
    //   }
    // });
    this.formGroup.get('countryId').valueChanges.subscribe((res) => {
      this.organizationService.getCity(res).subscribe((result: any) => {
        this.cities = result;
        this.formGroup.patchValue({cityId: null});
        if (this.cities.length === 1) {
          this.formGroup.patchValue({cityId: this.cities[0].id});
        }
      });
    });
    if (this.countries.length === 1) {
      this.formGroup.patchValue({countryId: this.countries[0].id});
    }
    this.defaultForm = this.formGroup.value;
    this.fuseConfig.role.subscribe(res => {
      if (res && (res === 'superAdmin' || res === 'subCountryAdmin' )) {
        const inputControlWhatsapp = this.formGroup.get('whatsapp');
        inputControlWhatsapp.enable();
      }
      if (res && res === 'superAdmin') {
        const inputControlAllowCompetency = this.formGroup.get('allowCompetency');
        inputControlAllowCompetency.enable();
        const inputControlAllowTimeAndBudget = this.formGroup.get('allowTimeAndBudget');
        inputControlAllowTimeAndBudget.enable();
      }
    });
  }

  addOrganization (returnToOrganization) {
    const data = this.formGroup.value;
    data.file = this.uploadedImg;
    this.organizationService.addOrganization(data).subscribe((res) => {
      this.returnBack = returnToOrganization;
      if (res && returnToOrganization) {
        this.organizationService.addSuccess = true;
        this.toastr.success('Organization added', 'Success!');
        this.router.navigate([ './pages/organization' ]);
      }
    });
  }

  goBack(): any{
    let dialogRef;
    if ((!this.compareForms() || this.uploadedImg) && !this.returnBack) {
      dialogRef = this.dialog.open(CheckModalComponent, {
        panelClass: 'unsave-form-dialog',
        width: '400px',
      });

      return dialogRef.afterClosed().toPromise().then((result: any) => {
        if (result === 'leave') {
          return true;
        } else if (result === 'save') {
          if (this.formGroup.valid) {
            this.addOrganization(false);
            return true;
          } else {
            this.snackBar.open('Please fill forms correctly', '', {duration: 2500});
            return false;
          }
        }
      });
    } else {
      return true;
    }
  }

  compareForms() {
    const values = Object.values(this.formGroup.value);
    const changes = values.filter(x => x && x !== '');
    return changes.length ? false : true;
  }

  setImg(img){
    this.uploadedImg = img;
  }
}
